module.exports = "/_next/static/images/screen-consultation-1-b49254d24315bc9f5813627ebdda1e36.png";